import React from 'react';
import { Splitter, SplitterPanel } from 'primereact/splitter';


export const CustomSplitter = (props) => {
    return (
        <Splitter style={{ height: '100vh' }}>
            <SplitterPanel size={props.splitSize.left}>
                {props.leftContent}
            </SplitterPanel>
            <SplitterPanel size={props.splitSize.right}>
                {props.rightContent}
            </SplitterPanel>
        </Splitter>
    );
}